import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { IProduct } from 'src/app/models/product/product.model';
import { IProviderOrganizationDocument, IProviderOrganizationDocumentSubType, IProviderOrganizationDocumentType, IProviderOrganizationFile, ProviderOrganizationDocumentSubType, ProviderOrganizationDocumentType, ProviderOrganizationFileType } from 'src/app/models/provider/provider-license.model';
import { IState } from 'src/app/models/state/state.model';
import { DocumentTypesService } from 'src/app/services/document-types.service';
import { UploadDocumentsComponent } from '../upload-documents/upload-documents.component';
import { DocumentsService } from 'src/app/services/documents.service';
import { ProviderDocumentService } from 'src/app/services/provider.document.service';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { DeleteConfirmationDialogService } from 'src/app/services/delete-confirmation-dialog.service';
import { DocumentModel, UPLOADSTATUS } from 'src/app/models/document/document.model';
import { debounceTime, Subject, takeUntil, tap } from 'rxjs';
import { CommonModule, DatePipe } from '@angular/common';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatMultiSelectComponent } from '../mat-multiselect/mat-multiselect.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RightSidebarContainerComponent } from '../right-sidebar-container/right-sidebar-container.component';
import { MatIconModule } from '@angular/material/icon';
import { ProviderDocumentCardComponent } from './provider-documents-card/provider-document-card.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { IIndustry } from 'src/app/models/Industry/industry.model';
import { Role } from 'src/app/models/user/role.model';
import { MatMenuModule } from '@angular/material/menu';
@Component({
    selector: 'app-provider-documents',
    templateUrl: './provider-documents.component.html',
    styleUrls: ['./provider-documents.component.scss'],
    standalone: true,
    imports: [
      CommonModule,
      MatMultiSelectComponent,
      MatFormFieldModule,
      MatInputModule,
      MatDatepickerModule,
      MatNativeDateModule,
      MatSidenavModule,
      RightSidebarContainerComponent,
      ReactiveFormsModule,
      MatRadioModule,
      UploadDocumentsComponent,
      MatIconModule,
      ProviderDocumentCardComponent,
      MatPaginatorModule,
      MatButtonToggleModule,
      MatButtonModule,
      MatSelectModule,
      MatMenuModule
    ]
})
export class ProviderDocumentsComponent implements OnInit, OnChanges, OnDestroy {
  ProviderOrganizationFileType = ProviderOrganizationFileType;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('documentFiles') documentFiles: UploadDocumentsComponent;
  @ViewChild('filingProofFiles') filingProofFiles: UploadDocumentsComponent;

  @Input() organizationId: string;
  @Input() states: IState[] = [];
  @Input() products: IProduct[] = [];
  @Input() industries: IIndustry[] = [];
  @Input() documentType: IProviderOrganizationDocumentType;
  @Input() organizationName: string = '';
  @Input() childOrganizations: any[] = [];
  @Input() pageSettings: {
    defaultPageSize: number,
    pageSizeOptions: number[],
  } = {
    defaultPageSize: 20,
    pageSizeOptions: [20, 50 ,100]
  }
  @Input() userRole: Role | undefined;
  @ViewChild('drawer') drawer: MatDrawer;

  public documentForm: FormGroup;

  public isLoadingLicenses: boolean = false;
  public isLoading: boolean = false;
  private initialized = false;
  private readonly destroy$ = new Subject<void>();

  public currentPage: number = 0;
  public pageSize: number = this.pageSettings.defaultPageSize;

  totalCount: number = 0;

  public providerLicenses: IProviderOrganizationDocument[] = [];
  public licenseToUpdate: IProviderOrganizationDocument | null;
  copyFilesToUpdate: any[] = [];
  filingProofFilesToUpdate: any[] = [];
  public availableOrganizations: any[] = [];

  public filterForm = new FormGroup({
    searchText: new FormControl(''),
    organizationId: new FormControl<number | null>(null),
    documentSubTypeId: new FormControl(0),
    industryIds: new FormControl<IIndustry[]>([]),
    stateIds: new FormControl<IState[]>([]),
    productIds: new FormControl<IProduct[]>([]),
    expirationDate: new FormControl(null)
  });

  datePipe = new DatePipe('en-US');

  sortOptions = [
    { label: 'Expiration Date', sortValue: 'expirationDate' },
  ];

  currentSortField: { sortValue: string } | null = null;
  currentIsAscending = true;

  sortForm: FormGroup = new FormGroup({
    sortField: new FormControl(this.currentSortField),
    isAscending: new FormControl(this.currentIsAscending),
  });

  public licenseActions = [
    {
      icon: 'delete',
      cssClass: 'danger outer icon-only',
      click: this.deleteLicense.bind(this)
    },
    {
      icon: 'download',
      cssClass: 'primary outer icon-only',
      click: this.downloadLicense.bind(this)
    },
    {
      icon: 'upload_file_outlined',
      cssClass: 'primary icon-only fill',
      click: this.uploadLicense.bind(this)
    }
  ]
  filters: {};
  isEditing = false;

  get isLender(): boolean {
    return this.userRole === Role.Lender;
  }

  get canUpload(): boolean {
    return this.userRole !== Role.Lender && this.userRole !== Role.ProviderReadOnly && this.userRole !== Role.LenderReadOnly;
  }

  get visibleLicenseActions() {
    return (this.isLender || this.userRole === Role.ProviderReadOnly || this.userRole === Role.LenderReadOnly) ? [] : this.licenseActions;
  }

  constructor(private providerOrganizationsService: ProviderDocumentService,
      private documentService: DocumentsService,
      public _MatPaginatorIntl: MatPaginatorIntl,
      private cdr: ChangeDetectorRef,
      private deleteDialog: DeleteConfirmationDialogService
  ) {

  }

  ngOnInit(): void {
    this._MatPaginatorIntl.itemsPerPageLabel = 'Show items per page';
    this.buildAvailableOrganizations();
    this.initializeDocumentForm();
    this.setDefaultOrganizationFilter();
    this.loadProviderLicenses();
    this.initialized = true;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.initialized) return;
    if (changes['childOrganizations']) {
      this.buildAvailableOrganizations();
      const selectedOrgId = this.filterForm.get('organizationId')?.value;
      const isStillAvailable = this.availableOrganizations.some(
        org => org.id == selectedOrgId
      );
      if (!isStillAvailable) {
        this.setDefaultOrganizationFilter();
        this.loadProviderLicenses();
      }
    }
  }
  private buildAvailableOrganizations() {
      this.availableOrganizations = [
      {
        id: parseInt(this.organizationId),
        name: this.organizationName
      },
      ...this.childOrganizations.map(child => ({
        id: child.id,
        name: child.name
      }))
    ];
  }
  get hasChildren(): boolean {
    return this.childOrganizations.length > 0;
  }
  get isOrgSelectorDisabled(): boolean {
    return this.isEditing;
  }
  get availableIndustries(): IIndustry[] {
    return this.industries.filter(i => i.id !== 0);
  }
  private setDefaultOrganizationFilter() {
    this.filterForm.get('organizationId')?.setValue(parseInt(this.organizationId), { emitEvent: false });
  }
  initializeDocumentForm(){
    this.documentForm = new FormGroup({
      organizationId: new FormControl(parseInt(this.organizationId), [Validators.required]),
      documentSubTypeId: new FormControl('', [Validators.required]),
      industryIds: new FormControl([]),
      productIds: new FormControl([]),
      stateIds: new FormControl([]),
      expirationDate: new FormControl(null),
      insuranceCompanyName: new FormControl(''),
      documentFiles: new FormControl<IProviderOrganizationFile[]>([]),
      filingProofFiles: new FormControl<IProviderOrganizationFile[]>([]),
    });

    this.documentForm.get('productIds')!.addValidators(this.customRequiredValidator(this.documentForm));
    this.documentForm.get('stateIds')!.addValidators(this.customRequiredValidator(this.documentForm));
    this.documentForm.get('industryIds')!.addValidators(this.customRequiredValidator(this.documentForm));
    this.documentForm.get('documentFiles')!.addValidators(this.documentFilesRequiredValidator());
    this.documentForm.updateValueAndValidity();

    this.filterForm.get('organizationId')?.valueChanges
    .pipe(debounceTime(300), takeUntil(this.destroy$), tap(() => { this.currentPage = 0; this.applyFilters(); }))
    .subscribe();

    this.filterForm.get('industryIds')?.valueChanges
    .pipe(debounceTime(300), takeUntil(this.destroy$), tap(() => { this.currentPage = 0; this.applyFilters(); }))
    .subscribe();
    this.filterForm.get('productIds')?.valueChanges
      .pipe(debounceTime(300), takeUntil(this.destroy$), tap(() => { this.currentPage = 0; this.applyFilters(); }))
      .subscribe();

    this.filterForm.get('stateIds')?.valueChanges
      .pipe(debounceTime(300), takeUntil(this.destroy$), tap(() => { this.currentPage = 0; this.applyFilters(); }))
      .subscribe();

    this.filterForm.get('searchText')?.valueChanges
      .pipe(debounceTime(300), takeUntil(this.destroy$), tap(() => { this.currentPage = 0; this.applyFilters(); }))
      .subscribe();
  }

  private loadProviderLicenses() {
    this.isLoadingLicenses = true;
    const selectedOrgId = this.filterForm.get('organizationId')?.value || this.organizationId;
    this.providerOrganizationsService
      .get({
        organizationId: selectedOrgId,
        documentTypeId: this.documentType.id,
        page: this.currentPage + 1,
        pageSize: this.pageSize,
        ...this.filters
      })
      .subscribe((response: any) => {
        this.isLoadingLicenses = false;
        if(!response.isError){
          this.providerLicenses = response.data.items;
          this.totalCount = response.data.totalCount;
        }
      });
  }

  closeRightSidebar(){
    this.resetFormValues();
    this.licenseToUpdate = null;
    this.copyFilesToUpdate = [];
    this.filingProofFilesToUpdate = [];
    this.drawer.close()
  }

  resetFormValues() {
    this.documentForm.reset();
    this.documentForm.get('organizationId')?.setValue(this.organizationId);
    this.documentForm.get('industryIds')?.setValue([]);
    this.documentFiles.clearFiles();
    this.filingProofFiles?.clearFiles();
  }

  openRightSidebar(isEditing: boolean) {
    this.isEditing = isEditing;
    if (!isEditing) {
    this.documentForm.get('organizationId')?.setValue(parseInt(this.organizationId));
    }
    this.drawer.toggle();
  }

  getSidebarTitle(): string{
    switch(this.documentType.id){
      case ProviderOrganizationDocumentType.LICENSES_PERMITS:
        return "Upload new License or Permit";
      case ProviderOrganizationDocumentType.FINANCIAL_SECURITY:
        return "Upload new Financial Security Doc";
      default:
        return "Upload new Document"
    }
  }

  getSubtypeName(subType: IProviderOrganizationDocumentSubType): string{
    if(this.documentType.id === ProviderOrganizationDocumentType.FINANCIAL_SECURITY &&
       subType.name.toLowerCase().startsWith('other')){
        return "Other (Bond, Proof of Funded Reserve, etc.)";
    }

    return subType.name;
  }

  getDataToSubmit(){
    const isAmBest = this.isSubtypeSelected(ProviderOrganizationDocumentSubType.AM_BEST_RATING);
    const data: any = {
      documentSubTypeId: this.documentForm.value.documentSubTypeId,
      productIds: this.documentForm.value.productIds.map((p: any) => p.id),
      stateIds: this.documentForm.value.stateIds.map((s: any) => s.id),
      expirationDate: this.documentForm.value.expirationDate,
      documentFiles: this.documentForm.value.documentFiles,
      insuranceCompanyName: this.isInsurancePolicySelected() ? (this.documentForm.value.insuranceCompanyName || null) : null,
    }

    if (!isAmBest) {
      data.industryIds = this.documentForm.value.industryIds.map((i: any) => i.id);
    }
    const filingProofFiles = this.documentForm.value.filingProofFiles;

    if(filingProofFiles && filingProofFiles.length > 0){
      data.documentFiles = data.documentFiles.concat(filingProofFiles);
    }

    return data;
  }

  onSubmit(){
    if(this.documentForm.valid) {
      const formData = this.getDataToSubmit();
      this.isLoading = true;
      if(this.licenseToUpdate){
        this.providerOrganizationsService
        .update(`${this.licenseToUpdate.id}`, formData)
        .subscribe(response => {
          this.isLoading = false;
          if(response && response.isError){
            return;
          }
          this.closeRightSidebar();
          this.loadProviderLicenses();
        });
      }
      else{
        const data = {
          ...formData,
          organizationId: this.documentForm.value.organizationId,
          documentTypeId: this.documentType.id
        }
        this.providerOrganizationsService
        .add(data)
        .subscribe(response => {
          this.isLoading = false;
          if(!response.isError){
            this.closeRightSidebar();
            this.loadProviderLicenses();
          }
        });
      }
    }
  }

  onFilingProofRemove(fileCount: number){
    this.documentForm.get('filingProofFiles')?.setValue(this.getFilingProofFiles());
    this.documentForm.updateValueAndValidity();
  }

  uploadingFilingProofEventHandler(status: boolean){
    this.isLoading = status;
    if (this.filingProofFiles.uploadedFiles().length > 0) {
      this.documentForm
        .get('filingProofFiles')
        ?.setValue(this.getFilingProofFiles());
    }
  }

uploadingLicenseCopyEventHandler(status: boolean){
  this.isLoading = status;
  if (this.documentFiles.uploadedFiles().length > 0) {
    this.documentForm
      .get('documentFiles')
      ?.setValue(this.getDocumentFiles());
  }
}

  getDocumentFiles(){
    return this.documentFiles.uploadedFiles().map(d => ({...d, fileType: ProviderOrganizationFileType.COPY}));
  }

  getFilingProofFiles(){
    return this.filingProofFiles.uploadedFiles().map(d => ({...d, fileType: ProviderOrganizationFileType.FILING_PROOF}));
  }

  getFileUploadDescription(): string{
    switch(this.documentType.id){
      case ProviderOrganizationDocumentType.LICENSES_PERMITS:
        return "Upload a copy of the license:";
      case ProviderOrganizationDocumentType.FINANCIAL_SECURITY:
        return this.isSubtypeSelected(ProviderOrganizationDocumentSubType.AM_BEST_RATING) ?
          "Upload documentation of underwriter’s or risk retention group’s A.M. Best rating:"
          : "Upload documentation of financial security requirement:"
      default:
        return "Upload document";
    }
  }

  isDocumentType(documentType: ProviderOrganizationDocumentType): boolean{
    return this.documentType.id === documentType;
  }

  isSubtypeSelected(subtype: ProviderOrganizationDocumentSubType): boolean{
    return this.documentForm.value.documentSubTypeId === subtype;
  }

  showFilingProofDropzone(): boolean{
    return this.isDocumentType(ProviderOrganizationDocumentType.FINANCIAL_SECURITY)
    && !this.isSubtypeSelected(ProviderOrganizationDocumentSubType.AM_BEST_RATING);
  }

  showApplicableStates(): boolean{
    return !this.isSubtypeSelected(ProviderOrganizationDocumentSubType.AM_BEST_RATING);
  }

  showProducts(): boolean{
    return !this.isSubtypeSelected(ProviderOrganizationDocumentSubType.AM_BEST_RATING);
  }

  showExpirationDate(): boolean{
    return !this.isSubtypeSelected(ProviderOrganizationDocumentSubType.AM_BEST_RATING);
  }

  showIndustry(): boolean{
    return !this.isSubtypeSelected(ProviderOrganizationDocumentSubType.AM_BEST_RATING);
  }

  isInsurancePolicySelected(subTypeId: any = this.documentForm.value.documentSubTypeId): boolean{
    const selectedSubType = this.documentType?.documentSubTypes?.find(
      s => s.id === subTypeId
    );
    return !!selectedSubType && selectedSubType.name.trim().toLowerCase() === 'insurance policy';
  }

  showInsuranceCompanyName(): boolean{
    return this.isInsurancePolicySelected();
  }

  handlePageEvent(event: PageEvent){
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;

    this.loadProviderLicenses();
  }

  onChangeFormSubtype(event: MatRadioChange){
    if(event.value === ProviderOrganizationDocumentSubType.AM_BEST_RATING){
      this.documentForm.get('productIds')?.setValue([]);
      this.documentForm.get('stateIds')?.setValue([]);
      this.documentForm.get('expirationDate')?.setValue(null);
      this.documentForm.get('industryIds')?.setValue([]);
      this.documentForm.get('filingProofFiles')?.setValue([]);
      this.filingProofFiles?.clearFiles();
    }
    if(!this.isInsurancePolicySelected(event.value)){
      this.documentForm.get('insuranceCompanyName')?.setValue('');
    }
    this.cdr.detectChanges();
  }

  onLicenseCopyRemove(fileCount: number){
    this.documentForm.get('documentFiles')?.setValue(this.getDocumentFiles());
    this.documentForm.updateValueAndValidity();
  }

  onDeleteConfirmation(document: IProviderOrganizationDocument){
    this.isLoadingLicenses = true;
    this.providerOrganizationsService
      .delete(`${document.id}`)
      .subscribe(
        _ => this.loadProviderLicenses()
      );
  }

  deleteLicense(document: IProviderOrganizationDocument): void{
    //TODO: call confirmation popup
    this.deleteDialog.openDeleteConfirmation("This document will be removed from the system.")
      .afterClosed()
      .subscribe(deleteConfirmation => {
        if(deleteConfirmation){
          this.onDeleteConfirmation(document);
        }
      });
  }

  downloadLicense(license: IProviderOrganizationDocument): void{
    license.documentFiles.forEach(lc => {
      this.documentService.downloadDocument({
        name: lc.name,
        serverFileName: lc.systemName
      });
    });
  }

  uploadLicense(license: IProviderOrganizationDocument): void{
    this.licenseToUpdate = license;
    this.documentForm.get('organizationId')?.setValue(license.organizationId);
    this.documentForm.get('documentSubTypeId')?.setValue(license.documentSubType.id);
    this.documentForm.get('industryIds')?.setValue(this.availableIndustries.filter(i => license.industries?.some(_i => _i.id === i.id)));
    this.documentForm.get('productIds')?.setValue(this.products.filter(p => license.products.some(_p => _p.id === p.id)));
    this.documentForm.get('stateIds')?.setValue(this.states.filter(s => license.applicableStates.some(_s => _s.id === s.id)));
    this.documentForm.get('expirationDate')?.setValue(license.expirationDate);
    this.documentForm.get('insuranceCompanyName')?.setValue(license.insuranceCompanyName || '');

    this.copyFilesToUpdate = this.licenseToUpdate?.documentFiles
    .filter(df => df.fileType === ProviderOrganizationFileType.COPY)
    .map(file => {
      const document =  new DocumentModel(
        new File([new Blob], file.name),
        UPLOADSTATUS.SUCCESS
      );

      document.serverFileName = file.systemName;
      return document;
    }) ?? [];

    this.filingProofFilesToUpdate = this.licenseToUpdate?.documentFiles
    .filter(df => df.fileType === ProviderOrganizationFileType.FILING_PROOF)
    .map(file => {
      const document =  new DocumentModel(
        new File([new Blob], file.name),
        UPLOADSTATUS.SUCCESS
      );

      document.serverFileName = file.systemName;
      return document;
    }) ?? [];



    this.documentForm.get('documentFiles')?.setValue(
      [...this.copyFilesToUpdate.map(f => ({name: f.file.name, serverFileName: f.serverFileName})),
      ...this.filingProofFilesToUpdate.map(f => ({name: f.file.name, serverFileName: f.serverFileName}))
    ]);
    this.openRightSidebar(true);
  }

  applyFilters() {
    const filters = this.filterForm.value;

    this.filters = {};

    if(filters.documentSubTypeId != 0){
      this.filters = {...this.filters, documentSubTypeId: filters.documentSubTypeId}
    }

    if (filters.searchText) {
      this.filters = {...this.filters, searchKey: filters.searchText!.toLowerCase()}
    }
    if (filters.industryIds && filters.industryIds.length > 0) {
      this.filters = {...this.filters, industryIds: filters.industryIds.map(i => i.id)}
    }
    if (filters.stateIds && filters.stateIds.length > 0) {
      this.filters = {...this.filters, stateIds: filters.stateIds.map(state => state.id)}
    }

    if (filters.productIds && filters.productIds.length > 0) {
      this.filters = {...this.filters, productIds: filters.productIds.map(state => state.id)}
    }

    if (filters.expirationDate) {
      const filterDate = this.datePipe.transform(filters.expirationDate, 'yyyy-MM-dd'); //normalize to midnight
      this.filters = {...this.filters, expirationDate: filterDate}
    }

    if (this.currentSortField) {
      this.filters = {
        ...this.filters,
        sortColumn: this.currentSortField.sortValue,
        isAscending: this.currentIsAscending
      }
    }

    this.loadProviderLicenses();
  }

  onSortApply() {
    const { sortField, isAscending } = this.sortForm.value;
    this.currentSortField = sortField;
    this.currentIsAscending = isAscending;
    this.currentPage = 0;
    this.applyFilters();
  }

  compareSortOptions(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.sortValue === o2.sortValue : o1 === o2;
  }

  documentFilesRequiredValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const noValue = !control.value || control.value.length === 0;
      return noValue ? { required: true } : null;
    };
  }

  customRequiredValidator(form: FormGroup): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const needRequire = form.get('documentSubTypeId')?.value != ProviderOrganizationDocumentSubType.AM_BEST_RATING
      const noValue = needRequire ? (!(control.value) || control.value?.length === 0) : false;
      return noValue ? {required: noValue} : null;
    };
  }

}
